import { BoxProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { Quote } from '../../../domain'
import { ProductConfig } from '../../../state/configuration'
import { usePaymentSchedule } from '../../product/paymentScheduleContext'
import { AnnualSummaryPremiumMonthly } from './AnnualSummaryPremiumMonthly'
import { AnnualSummaryPremiumYearly } from './AnnualSummaryPremiumYearly'

export interface AnnualSummaryPremiumsProps extends BoxProps {
  currentQuote: Quote
  product: ProductConfig
}

export const AnnualSummaryPremium: FunctionComponent<AnnualSummaryPremiumsProps> = ({
  currentQuote,
  ...props
}) => {
  const { paymentScheduleType } = usePaymentSchedule()

  switch (paymentScheduleType) {
    case 'MONTHLY':
      return <AnnualSummaryPremiumMonthly currentQuote={currentQuote} {...props} />
    case 'SINGLE_PAYMENT':
      return <AnnualSummaryPremiumYearly currentQuote={currentQuote} {...props} />
    default:
      return null
  }
}
